module.exports = __webpack_public_path__ + "media/images/themes/democracy-and-justice-a0e398cb9013da5b33bdc9e97a659de1.png";